import { FC } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Tabs } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

const MainMenu: FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isMobile = useMediaQuery('(max-width: 767px)');

    const menuItems = [
        { name: 'Etusivu', path: '/' },
        { name: 'Info', path: '/info' },
        { name: 'Ilmoittautuminen', path: '/registration' },
        { name: 'Pöytävaraus', path: '/booking' },
        { name: 'Turnaukset', path: '/tournaments' },
        { name: 'Intra', path: '/intra' },
    ];

    return (
        <>
            <Tabs
                variant="pills"
                autoContrast={true}
                color="violet.5"
                orientation={isMobile ? 'vertical' : 'horizontal'}
                value={location.pathname}
                onChange={value => value && navigate(value)}>
                <Tabs.List grow={true}>
                    {menuItems.map((item) => (
                        <Tabs.Tab key={item.path} value={item.path}>
                            {item.name}
                        </Tabs.Tab>
                    ))}
                </Tabs.List>
            </Tabs>
        </>
    );
};

export default MainMenu;
